import { ComponentProps } from "react";
import { Tag } from "@jsq/ds/core";
import { TicketStatus } from "#graphql/supergraphEnums";
import { TICKET_STATUS_DISPLAY_MAP } from "../../constants";

export function formatChildWorkItemStatus(status: string): string {
  const upperStatus = status.toUpperCase().replace(/\s+/g, "_");
  return (
    TICKET_STATUS_DISPLAY_MAP[upperStatus as keyof typeof TICKET_STATUS_DISPLAY_MAP] || status
  );
}

export function getStatusTagVariant(
  status: string,
): NonNullable<ComponentProps<typeof Tag>["variant"]> {
  const upperStatus = status.toUpperCase() as TicketStatus;

  if (upperStatus === TicketStatus.Complete || upperStatus === TicketStatus.Done) {
    return "success";
  }

  if (
    upperStatus === TicketStatus.Maker ||
    upperStatus === TicketStatus.Checker ||
    upperStatus === TicketStatus.Incomplete
  ) {
    return "informative";
  }

  return "neutral";
}

export function isTaskCompleted(status: string): boolean {
  const upperStatus = status.toUpperCase() as TicketStatus;
  return upperStatus === TicketStatus.Complete || upperStatus === TicketStatus.Done;
}

export function extractDescriptionAfterColon(summary: string): string {
  const colonIndex = summary.indexOf(":");
  if (colonIndex === -1) {
    return summary;
  }
  return summary.slice(colonIndex + 1).trim();
}
